import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import Home from "@/pages/Home";
import Planner from "@/pages/Planner";
import Admin from "@/pages/Admin";
import Login from "@/pages/Login";
import Portal from "@/pages/Portal";
import Solutions from "@/pages/Solutions";
import CmsPage from "@/pages/CmsPage";
import CmsAdmin from "@/pages/CmsAdmin";
import AiConsole from "@/pages/AiConsole";
import LeadCrm from "@/pages/LeadCrm";
import AdminAnalytics from "@/pages/AdminAnalytics";
import FoodPulse from "@/pages/FoodPulse";
import RedesignGallery from "@/pages/RedesignGallery";
import ConceptPreview from "@/pages/ConceptPreview";
import WebsiteMakeover from "@/pages/WebsiteMakeover";
import AdminClients from "@/pages/AdminClients";
import ClientDashboard from "@/pages/ClientDashboard";
import AssistantPage from "@/pages/AssistantPage";
import AuthCallback from "@/pages/AuthCallback";
import ServicePage from "@/pages/ServicePage";
import LeadGenOverview from "@/pages/LeadGenOverview";
import LeadGenAuditTool from "@/pages/LeadGenAuditTool";
import LeadGenAuditShared from "@/pages/LeadGenAuditShared";
import LeadGenIndustryLocation from "@/pages/LeadGenIndustryLocation";
import LeadGenBundles from "@/pages/LeadGenBundles";
import ClientGrowthDashboard from "@/pages/ClientGrowthDashboard";
import GrowthAdvisor from "@/pages/GrowthAdvisor";
import GrowthAdvisorWidget from "@/components/GrowthAdvisorWidget";
import AiChatbot from "@/pages/AiChatbot";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import IndiaLayout from "@/pages/india/IndiaLayout";
import IndiaHome from "@/pages/india/IndiaHome";
import IndiaServices from "@/pages/india/IndiaServices";
import IndiaPricing from "@/pages/india/IndiaPricing";
import IndiaAudit from "@/pages/india/IndiaAudit";
import IndiaContact from "@/pages/india/IndiaContact";
import IndiaGeo from "@/pages/india/IndiaGeo";
import IndiaPortal from "@/pages/india/IndiaPortal";
import AdminCountry from "@/pages/AdminCountry";
import AdminEnquiries from "@/pages/AdminEnquiries";
import AdminProspects from "@/pages/AdminProspects";
import AdminLaunchChats from "@/pages/AdminLaunchChats";
import ConversationHubLanding from "@/pages/ConversationHubLanding";
import GrowthAudit from "@/pages/GrowthAudit";
import GrowthTaskCenter from "@/pages/GrowthTaskCenter";
import AIVisibilityMonitor from "@/pages/AIVisibilityMonitor";
import AIVisibilityDigestPreview from "@/pages/AIVisibilityDigestPreview";
import DigestAnalytics from "@/pages/DigestAnalytics";
import IndustryKits from "@/pages/IndustryKits";
import ProofWall from "@/pages/ProofWall";
import SocialStudio from "@/pages/SocialStudio";
import AdBuilder from "@/pages/AdBuilder";
import VisualStudio from "@/pages/VisualStudio";
import MyCampaigns from "@/pages/MyCampaigns";
import AdLibrary from "@/pages/AdLibrary";
import LocalPresence from "@/pages/LocalPresence";
import VisualStudioFaq from "@/pages/VisualStudioFaq";
import AdApproval from "@/pages/AdApproval";
import About from "@/pages/About";
import ConversationHubInbox from "@/pages/ConversationHubInbox";
import ConversationHubSettings from "@/pages/ConversationHubSettings";
import AdminKerala from "@/pages/AdminKerala";
import AdminRedesign from "@/pages/AdminRedesign";
import KeralaLayout from "@/pages/kerala/KeralaLayout";
import KeralaHome from "@/pages/kerala/KeralaHome";
import KeralaServices from "@/pages/kerala/KeralaServices";
import KeralaPricing from "@/pages/kerala/KeralaPricing";
import KeralaAudit from "@/pages/kerala/KeralaAudit";
import KeralaContact from "@/pages/kerala/KeralaContact";
import KeralaGallery from "@/pages/kerala/KeralaGallery";
import KeralaPartners from "@/pages/kerala/KeralaPartners";
import KeralaPartnerPortal from "@/pages/kerala/KeralaPartnerPortal";
import BoardDemo from "@/pages/BoardDemo";
import SeoIntelligence from "@/pages/SeoIntelligence";
import SeoAnalyzerPage from "@/pages/SeoAnalyzerPage";
import RightsQueue from "@/pages/RightsQueue";
import MyWebsiteTechDashboard from "@/pages/MyWebsiteTechDashboard";
import SeoRegressionDashboard from "@/pages/SeoRegressionDashboard";
import AnalyticsConnectors from "@/pages/AnalyticsConnectors";
import CrescentHome from "@/pages/crescent/CrescentHome";
import CrescentProductDetail from "@/pages/crescent/CrescentProductDetail";
import CrescentProductsIndex from "@/pages/crescent/CrescentProductsIndex";
import CrescentIndustryDetail from "@/pages/crescent/CrescentIndustryDetail";
import CrescentIndustriesIndex from "@/pages/crescent/CrescentIndustriesIndex";
import CrescentCapabilityDetail, { CrescentCapabilitiesIndex } from "@/pages/crescent/CrescentCapabilityDetail";
import CrescentContentPage from "@/pages/crescent/CrescentContentPage";
import CrescentRequestQuote from "@/pages/crescent/CrescentRequestQuote";
import { CrescentI18nProvider } from "@/pages/crescent/CrescentI18n";
import { GrowIntake, GrowDashboard, GrowApprovals, GrowLeads } from "@/pages/grow/GrowAgent";
import { GrowAudiences, GrowChannels } from "@/pages/grow/GrowPhase2";
import NotFound from "@/pages/NotFound";
import SelfCanonical from "@/components/SelfCanonical";
import PublishedPage from "@/pages/PublishedPage";
import PublicAudit from "@/pages/PublicAudit";
import ToolsCatalog from "@/pages/ToolsCatalog";
import GrowthAgentPage from "@/pages/GrowthAgentPage";
import EmbedStudio from "@/pages/EmbedStudio";
import AiVisibility from "@/pages/AiVisibility";
import RevenueCenter from "@/pages/revenue/RevenueCenter";
import Prospecting from "@/pages/revenue/Prospecting";
import Receptionist from "@/pages/revenue/Receptionist";
import Outreach from "@/pages/revenue/Outreach";
import Timeline from "@/pages/revenue/Timeline";
import RevenueDashboard from "@/pages/revenue/RevenueDashboard";
import Revival from "@/pages/revenue/Revival";
import TrustCenter from "@/pages/revenue/TrustCenter";
import RevenuePackages from "@/pages/revenue/RevenuePackages";
import WhatsNew from "@/pages/WhatsNew";
import PricingPage from "@/pages/PricingPage";
import AdminPricing from "@/pages/AdminPricing";
import IndustryPage from "@/pages/IndustryPage";
import AdminIndustryPages from "@/pages/AdminIndustryPages";
import AdminProposals from "@/pages/AdminProposals";
import AdminDemoLeads from "@/pages/AdminDemoLeads";
import AdminToolsCatalog from "@/pages/AdminToolsCatalog";
import AdminWhatsNew from "@/pages/AdminWhatsNew";
import AdminEmbed from "@/pages/AdminEmbed";
import AdminAiVisibility from "@/pages/AdminAiVisibility";
import ReceptionistStudio from "@/pages/ReceptionistStudio";
import ManageBooking from "@/pages/ManageBooking";
import CommunicationCenter from "@/pages/CommunicationCenter";
import LeadCustomerCenter from "@/pages/LeadCustomerCenter";
import WebsiteTechCenter from "@/pages/WebsiteTechCenter";
import RepresentativeStudio from "@/pages/RepresentativeStudio";
import AiRepresentativePage from "@/pages/AiRepresentativePage";
import FeedbackStudio from "@/pages/FeedbackStudio";
import AiFeedbackPage from "@/pages/AiFeedbackPage";
import PublicSurveyPage from "@/pages/PublicSurveyPage";
import VoiceCommunicationHub from "@/pages/VoiceCommunicationHub";
import MissedCallConsole from "@/pages/MissedCallConsole";
import CopilotConsole from "@/pages/CopilotConsole";
import BuildAgentWizard from "@/pages/BuildAgentWizard";
import AiVoicePage from "@/pages/AiVoicePage";
import AiLccPage from "@/pages/AiLccPage";
import AiWtcPage from "@/pages/AiWtcPage";
import AiCopilotPage from "@/pages/AiCopilotPage";
import AiMissedCallPage from "@/pages/AiMissedCallPage";
import TrustPhase2 from "@/pages/TrustPhase2";
import WorkflowBuilder from "@/pages/WorkflowBuilder";
import BusinessCenter from "@/pages/BusinessCenter";
import BusinessCenterAssessment from "@/pages/BusinessCenterAssessment";
import BusinessCenterAssessmentReport from "@/pages/BusinessCenterAssessmentReport";
import BusinessCenterMethodology from "@/pages/BusinessCenterMethodology";
import BusinessCenterTools from "@/pages/BusinessCenterTools";
import BusinessCenterStackBuilder from "@/pages/BusinessCenterStackBuilder";
import { BusinessCenterPlaybooks, BusinessCenterPlaybookDetail } from "@/pages/BusinessCenterPlaybooks";
import { BusinessCenterCalculators, BusinessCenterCalculatorDetail } from "@/pages/BusinessCenterCalculators";
import BusinessCenterCompare from "@/pages/BusinessCenterCompare";
import { BusinessCenterGuides, BusinessCenterGuideDetail } from "@/pages/BusinessCenterGuides";
import BusinessCenterBrief from "@/pages/BusinessCenterBrief";
import AdminBrief from "@/pages/AdminBrief";
import LeadResponsePage from "@/pages/LeadResponsePage";
import LeadResponseInbox from "@/pages/LeadResponseInbox";
import AdminNumberHealth from "@/pages/AdminNumberHealth";
import DialerWorkspace from "@/pages/DialerWorkspace";
import AdminLrTemplates from "@/pages/AdminLrTemplates";
import AiAssistantsHub, { AiAssistantDetail } from "@/pages/AiAssistantsHub";
import AiCommerceIntelligence from "@/pages/AiCommerceIntelligence";
import CommercePortal from "@/pages/CommercePortal";
import StudioApp from "@/pages/StudioApp";
import StudioFeaturePage from "@/pages/StudioFeaturePage";
import QstHomePage from "@/qst/QstHomePage";
import QstTradesPage from "@/qst/QstTradesPage";
import QstTradeDetailPage from "@/qst/QstTradeDetailPage";
import QstLessonPage from "@/qst/QstLessonPage";
import QstLibraryPage from "@/qst/QstLibraryPage";
import QstToolsPage from "@/qst/QstToolsPage";
import { QstReworkCalcPage, QstInjuryCalcPage } from "@/qst/QstCalculatorPages";
import QstPricingPage from "@/qst/QstPricingPage";
import QstContactPage from "@/qst/QstContactPage";
import QstStoryPage from "@/qst/QstStoryPage";
import QstForOrganizationsPage, {
  QstAboutPage, QstSolutionsPage, QstResourcesPage,
  QstToolPlaceholderPage, QstSignupPage,
} from "@/qst/QstOtherPages";
import QstContractorDashboard from "@/qst/QstContractorDashboard";
import SpLinkPortal from "@/pages/SpLinkPortal";
import AssistantMarketingPage, { AssistantsLandingPage } from "@/pages/AssistantMarketingPage";
import AdminAssistantsAnalytics from "@/pages/AdminAssistantsAnalytics";
import SearchIntelligenceLanding from "@/pages/SearchIntelligenceLanding";
import SearchIntelligenceMethodology from "@/pages/SearchIntelligenceMethodology";
import SearchIntelligenceSample from "@/pages/SearchIntelligenceSample";
import SearchIntelligenceConsole from "@/pages/SearchIntelligenceConsole";
import AdminClientInventory from "@/pages/AdminClientInventory";
import GrowthOperatorLanding from "@/pages/GrowthOperatorLanding";
import GrowthOperatorBlueprint from "@/pages/GrowthOperatorBlueprint";
import AdminGrowthOperator from "@/pages/AdminGrowthOperator";
import GrowthOperatorHub from "@/pages/GrowthOperatorHub";
import GrowthOperatorPack from "@/pages/GrowthOperatorPack";
import AdminIrisAnalytics from "@/pages/AdminIrisAnalytics";
// LitLab.com fork — self-contained under /litlab/*
import { LitLabHome, LitLabAbout } from "@/litlab/pages/LitLabHome";
import { LitLabServices, LitLabIndustries, LitLabIndustryDetail } from "@/litlab/pages/LitLabServices";
import { LitLabQuote, LitLabContact } from "@/litlab/pages/LitLabQuote";
import { LitLabCaseStudies, LitLabCaseStudyDetail } from "@/litlab/pages/LitLabCaseStudies";
import LitLabCms from "@/litlab/pages/LitLabCms";
import LitLabServicePage from "@/litlab/pages/LitLabServicePage";

// AI Launch Program (Phase 1a) — application funnel + preview + admin
import LaunchProgramPage from "@/launch/pages/LaunchProgramPage";
import LaunchPreviewPage from "@/launch/pages/LaunchPreviewPage";
import LaunchStatusPortal from "@/pages/LaunchStatusPortal";
import LaunchDesignsPage from "@/launch/pages/LaunchDesignsPage";
import LaunchShowcasePage from "@/launch/pages/LaunchShowcasePage";
import LaunchShowcaseDetailPage from "@/launch/pages/LaunchShowcaseDetailPage";
import AdminLaunchPage from "@/launch/pages/AdminLaunchPage";

// AI Growth Center — Phase 1 (Brand Brain, Audit, Visibility, Creative, Approvals)
import GrowthCenterPage from "@/growth/pages/GrowthCenterPage";

// Clients portfolio hub — dual-hosted on clients.websitetech.pro and /clients
import ClientsHub from "@/pages/ClientsHub";

// Local Growth slices — shipped shallow-but-complete pending Phase 0 audit signoff
import LocalVisibilityLanding from "@/pages/LocalVisibilityLanding";
import UnifiedInboxPage from "@/pages/UnifiedInboxPage";
import PackagesPage from "@/pages/PackagesPage";
import MarketingManagerPage from "@/pages/MarketingManagerPage";
import ReputationCenterPage from "@/pages/ReputationCenterPage";
import OnboardingWizard from "@/pages/OnboardingWizard";
import InfographicsGallery from "@/pages/InfographicsGallery";
import ExecutiveDashboard from "@/pages/ExecutiveDashboard";
import ContactsPage from "@/pages/ContactsPage";
import EstimatesInvoicesPage from "@/pages/EstimatesInvoicesPage";
import PayInvoicePage from "@/pages/PayInvoicePage";
import LocationsRollupPage from "@/pages/LocationsRollupPage";
import BusinessIdentityAdmin from "@/pages/BusinessIdentityAdmin";
import CaseStudiesPage from "@/pages/CaseStudiesPage";
import EditorialStudio from "@/pages/EditorialStudio";
import AdminWorklog from "@/pages/AdminWorklog";
import AdminExperiments from "@/pages/AdminExperiments";
import AdminVersions from "@/pages/AdminVersions";
import FeaturesPage from "@/pages/FeaturesPage";
import DemosIndex from "@/pages/demos/DemosIndex";
import AureliaDemo from "@/pages/demos/AureliaDemo";
import MayaBennettDemo from "@/pages/demos/MayaBennettDemo";
import MedicalDemo from "@/pages/demos/MedicalDemo";
import LawDemo from "@/pages/demos/LawDemo";
import StillwaterDemo from "@/pages/demos/StillwaterDemo";
import ElaraDemo from "@/pages/demos/ElaraDemo";
import HarvestBridgeDemo from "@/pages/demos/HarvestBridgeDemo";
import AmaraValeDemo from "@/pages/demos/AmaraValeDemo";
import SolaraCoveDemo from "@/pages/demos/SolaraCoveDemo";
import LumeDemo from "@/pages/demos/LumeDemo";
import PrecisionAutoDemo from "@/pages/demos/PrecisionAutoDemo";
import FreshMarketDemo from "@/pages/demos/FreshMarketDemo";
import CedarGroveDemo from "@/pages/demos/CedarGroveDemo";
import NexoraDemo from "@/pages/demos/NexoraDemo";
import AIAssistant from "@/components/AIAssistant";
import TalkToAiEmployeeLauncher from "@/components/TalkToAiEmployeeLauncher";
import { initLanguage, translateOnRouteChange } from "@/lib/translator";

function ScrollManager() {
  const { pathname } = useLocation();
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);
  useEffect(() => { initLanguage(); }, []);
  useEffect(() => { translateOnRouteChange(); }, [pathname]);
  return null;
}

function App() {
  // Host-aware routing: `clients.websitetech.pro` mounts the ClientsHub at `/`
  // and hides the WebsiteTech shell around the QST / LitLab brand pages.
  const isClientsSubdomain =
    typeof window !== "undefined" &&
    /^clients\./i.test(window.location.hostname);

  return (
    <div className="App" data-clients-subdomain={isClientsSubdomain ? "1" : "0"}>
      <BrowserRouter>
        <AuthProvider>
          <ScrollManager />
          <SelfCanonical />
          <GrowthAdvisorWidget />
          <Routes>
            <Route path="/" element={isClientsSubdomain ? <ClientsHub isClientsSubdomain /> : <Home />} />
            <Route path="/clients" element={<ClientsHub isClientsSubdomain={isClientsSubdomain} />} />
            <Route path="/local-visibility" element={<LocalVisibilityLanding />} />
            <Route path="/inbox" element={<UnifiedInboxPage />} />
            <Route path="/packages" element={<PackagesPage />} />
            <Route path="/marketing-manager" element={<MarketingManagerPage />} />
            <Route path="/reputation" element={<ReputationCenterPage />} />
            <Route path="/onboarding" element={<OnboardingWizard />} />
            <Route path="/features/gallery" element={<InfographicsGallery />} />
            <Route path="/dashboard" element={<ExecutiveDashboard />} />
            <Route path="/contacts" element={<ContactsPage />} />
            <Route path="/estimates" element={<EstimatesInvoicesPage />} />
            <Route path="/invoices" element={<EstimatesInvoicesPage />} />
            <Route path="/pay/:iid" element={<PayInvoicePage />} />
            <Route path="/pay/rzp/:iid" element={<PayInvoicePage />} />
            <Route path="/dashboard/locations" element={<LocationsRollupPage />} />
            <Route path="/admin/identity" element={<BusinessIdentityAdmin />} />
            <Route path="/case-studies" element={<CaseStudiesPage />} />
            <Route path="/planner" element={<Planner />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/admin/launch" element={<AdminLaunchPage />} />
            <Route path="/launch" element={<LaunchProgramPage />} />
            <Route path="/launch/designs" element={<LaunchDesignsPage />} />
            <Route path="/launch/showcase" element={<LaunchShowcasePage />} />
            <Route path="/launch/showcase/:slug" element={<LaunchShowcaseDetailPage />} />
            <Route path="/launch/preview/:token" element={<LaunchPreviewPage />} />
            <Route path="/launch/status/:token" element={<LaunchStatusPortal />} />
            <Route path="/hub" element={<ConversationHubLanding />} />
            <Route path="/growth-audit" element={<GrowthAudit />} />
            <Route path="/growth-audit/:auditId" element={<GrowthAudit />} />
            <Route path="/growth-tasks" element={<GrowthTaskCenter />} />
            <Route path="/dashboard/growth" element={<GrowthTaskCenter />} />
            <Route path="/ai-visibility-monitor" element={<AIVisibilityMonitor />} />
            <Route path="/ai-visibility-monitor/digest-preview" element={<AIVisibilityDigestPreview />} />
            <Route path="/admin/digest-analytics" element={<DigestAnalytics />} />
            <Route path="/industry-kits" element={<IndustryKits />} />
            <Route path="/industry-kits/:code" element={<IndustryKits />} />
            <Route path="/proof" element={<ProofWall />} />
            <Route path="/proof/:slug" element={<ProofWall />} />
            <Route path="/social-studio" element={<SocialStudio />} />
            <Route path="/ad-builder" element={<VisualStudio />} />
            <Route path="/visual-studio" element={<VisualStudio />} />
            <Route path="/ad-builder/classic" element={<AdBuilder />} />
            <Route path="/ad-builder/library" element={<AdLibrary />} />
            <Route path="/my-campaigns" element={<MyCampaigns />} />
            <Route path="/local-presence" element={<LocalPresence />} />
            <Route path="/visual-studio-faq" element={<VisualStudioFaq />} />
            <Route path="/ad-builder/faq" element={<VisualStudioFaq />} />
            <Route path="/ad-approval/:token" element={<AdApproval />} />
            <Route path="/about" element={<About />} />
            <Route path="/hub/inbox" element={<ConversationHubInbox />} />
            <Route path="/hub/inbox/:conversationId" element={<ConversationHubInbox />} />
            <Route path="/hub/settings" element={<ConversationHubSettings />} />
            <Route path="/growth-center" element={<GrowthCenterPage />} />
            <Route path="/login" element={<Login />} />
            <Route path="/auth/socialpulse-callback" element={<AuthCallback />} />
            {/* Legacy path kept temporarily so any in-flight /auth/callback links still land */}
            <Route path="/auth/callback" element={<AuthCallback />} />
            <Route path="/portal" element={<Portal />} />
            <Route path="/receptionist" element={<ReceptionistStudio />} />
            <Route path="/r/:aid" element={<ManageBooking />} />
            <Route path="/communication-center" element={<CommunicationCenter />} />
            <Route path="/lcc" element={<LeadCustomerCenter />} />
            <Route path="/wtc" element={<WebsiteTechCenter />} />
            <Route path="/representative" element={<RepresentativeStudio />} />
            <Route path="/representative/:rid" element={<RepresentativeStudio />} />
            <Route path="/ai-representative" element={<AiRepresentativePage />} />
            <Route path="/feedback" element={<FeedbackStudio />} />
            <Route path="/feedback/:sid" element={<FeedbackStudio />} />
            <Route path="/ai-feedback" element={<AiFeedbackPage />} />
            <Route path="/s/:token" element={<PublicSurveyPage />} />
            <Route path="/voice" element={<VoiceCommunicationHub />} />
            <Route path="/missed-calls" element={<MissedCallConsole />} />
            <Route path="/copilot" element={<CopilotConsole />} />
            <Route path="/build-agent" element={<BuildAgentWizard />} />
            <Route path="/ai-voice" element={<AiVoicePage />} />
            <Route path="/ai-lcc" element={<AiLccPage />} />
            <Route path="/ai-wtc" element={<AiWtcPage />} />
            <Route path="/ai-copilot" element={<AiCopilotPage />} />
            <Route path="/ai-missed-call" element={<AiMissedCallPage />} />
            <Route path="/trust" element={<TrustPhase2 />} />
            <Route path="/workflows" element={<WorkflowBuilder />} />
            <Route path="/workflows/:wid" element={<WorkflowBuilder />} />
            <Route path="/business-center" element={<BusinessCenter />} />
            <Route path="/business-center/assessment" element={<BusinessCenterAssessment />} />
            <Route path="/business-center/assessment/:aid/report" element={<BusinessCenterAssessmentReport />} />
            <Route path="/business-center/methodology" element={<BusinessCenterMethodology />} />
            <Route path="/business-center/tools" element={<BusinessCenterTools />} />
            <Route path="/business-center/stack-builder" element={<BusinessCenterStackBuilder />} />
            <Route path="/business-center/playbooks" element={<BusinessCenterPlaybooks />} />
            <Route path="/business-center/playbooks/:slug" element={<BusinessCenterPlaybookDetail />} />
            <Route path="/business-center/calculators" element={<BusinessCenterCalculators />} />
            <Route path="/business-center/calculators/:kind" element={<BusinessCenterCalculatorDetail />} />
            <Route path="/business-center/editorial" element={<EditorialStudio />} />
            <Route path="/business-center/compare" element={<BusinessCenterCompare />} />
            <Route path="/business-center/guides" element={<BusinessCenterGuides />} />
            <Route path="/business-center/guides/:slug" element={<BusinessCenterGuideDetail />} />
            <Route path="/business-center/brief" element={<BusinessCenterBrief />} />
            <Route path="/admin/brief" element={<AdminBrief />} />
            <Route path="/ai-lead-response" element={<LeadResponsePage />} />
            <Route path="/portal/lead-response" element={<LeadResponseInbox />} />
            <Route path="/admin/number-health" element={<AdminNumberHealth />} />
            <Route path="/portal/dialer" element={<DialerWorkspace />} />
            <Route path="/admin/lr-templates" element={<AdminLrTemplates />} />
            {/* AI Assistants Hub — universal LLM test bed */}
            <Route path="/portal/assistants" element={<AiAssistantsHub />} />
            <Route path="/portal/commerce" element={<CommercePortal />} />
            <Route path="/studio" element={<StudioApp />} />
            <Route path="/solutions/studio/:slug" element={<StudioFeaturePage />} />

            {/* ============ QST — Quality Safety Times client site ============ */}
            <Route path="/qst"                        element={<QstHomePage />} />
            <Route path="/qst/trades"                 element={<QstTradesPage />} />
            <Route path="/qst/trades/:slug"           element={<QstTradeDetailPage />} />
            <Route path="/qst/library"                element={<QstLibraryPage />} />
            <Route path="/qst/lessons/:slug"          element={<QstLessonPage />} />
            <Route path="/qst/tools"                  element={<QstToolsPage />} />
            <Route path="/qst/tools/rework-cost"      element={<QstReworkCalcPage />} />
            <Route path="/qst/tools/injury-cost"      element={<QstInjuryCalcPage />} />
            <Route path="/qst/tools/training-savings" element={<QstToolPlaceholderPage title="Training Savings Calculator" subtitle="Coming soon — compare training investment against potential cost avoidance." />} />
            <Route path="/qst/tools/toolbox-builder"  element={<QstToolPlaceholderPage title="Toolbox Talk Builder" subtitle="Draft a customized talk from an approved QST lesson — requires supervisor approval before assignment." />} />
            <Route path="/qst/tools/checklist"        element={<QstToolPlaceholderPage title="Material Verification Checklist" subtitle="A pre-install checklist that pulls from the current trade's approved lesson." />} />
            <Route path="/qst/tools/qr-generator"     element={<QstToolPlaceholderPage title="QR Code Lesson Generator" subtitle="Generate a scannable QR for any approved lesson." />} />
            <Route path="/qst/pricing"                element={<QstPricingPage />} />
            <Route path="/qst/for-organizations"      element={<QstForOrganizationsPage />} />
            <Route path="/qst/about"                  element={<QstAboutPage />} />
            <Route path="/qst/contact"                element={<QstContactPage />} />
            <Route path="/qst/story/tell"             element={<QstStoryPage />} />
            <Route path="/qst/resources"              element={<QstResourcesPage />} />
            <Route path="/qst/solutions/:slug"        element={<QstSolutionsPage />} />
            <Route path="/qst/solutions"              element={<QstSolutionsPage />} />
            <Route path="/qst/signup"                 element={<QstSignupPage />} />
            <Route path="/qst/signin"                 element={<QstSignupPage />} />
            <Route path="/qst/dashboard/contractor"   element={<QstContractorDashboard />} />
            <Route path="/qst/dashboard"              element={<QstContractorDashboard />} />
            <Route path="/portal/links" element={<SpLinkPortal />} />
            <Route path="/solutions/ai-commerce-intelligence" element={<AiCommerceIntelligence />} />
            <Route path="/portal/assistants/:key" element={<AiAssistantDetail />} />
            {/* Public marketing pages for each assistant */}
            <Route path="/ai-assistants" element={<AssistantsLandingPage />} />
            <Route path="/ai-assistants/:key" element={<AssistantMarketingPage />} />
            {/* Admin analytics */}
            <Route path="/admin/assistants-analytics" element={<AdminAssistantsAnalytics />} />
            <Route path="/admin/iris-analytics" element={<AdminIrisAnalytics />} />
            {/* LitLab.com fork — self-contained section */}
            <Route path="/litlab" element={<LitLabHome />} />
            <Route path="/litlab/about" element={<LitLabAbout />} />
            <Route path="/litlab/services" element={<LitLabServices />} />
            <Route path="/litlab/services/:slug" element={<LitLabServicePage />} />
            <Route path="/litlab/industries" element={<LitLabIndustries />} />
            <Route path="/litlab/industries/:slug" element={<LitLabIndustryDetail />} />
            <Route path="/litlab/case-studies" element={<LitLabCaseStudies />} />
            <Route path="/litlab/case-studies/:slug" element={<LitLabCaseStudyDetail />} />
            <Route path="/litlab/quote" element={<LitLabQuote />} />
            <Route path="/litlab/admin/articles" element={<LitLabCms />} />
            <Route path="/litlab/contact" element={<LitLabContact />} />
            <Route path="/solutions" element={<Solutions />} />
            <Route path="/solutions/:slug" element={<Solutions />} />
            <Route path="/build/:slug" element={<ServicePage category="build" />} />
            <Route path="/improve/:slug" element={<ServicePage category="improve" />} />
            <Route path="/ai/:slug" element={<ServicePage category="ai" />} />
            <Route path="/analytics/:slug" element={<ServicePage category="analytics" />} />
            <Route path="/lead-generation" element={<LeadGenOverview />} />
            <Route path="/lead-generation/bundles" element={<LeadGenBundles />} />
            <Route path="/lead-generation/audit" element={<LeadGenAuditTool />} />
            <Route path="/lead-generation/audit/:token" element={<LeadGenAuditShared />} />
            <Route path="/lead-generation/:industry/:location" element={<LeadGenIndustryLocation />} />
            <Route path="/lead-generation/:slug" element={<ServicePage category="leadgen" />} />
            <Route path="/my" element={<ClientGrowthDashboard />} />
            <Route path="/growth-advisor" element={<GrowthAdvisor />} />
            <Route path="/resources/:slug" element={<ServicePage category="resources" />} />
            <Route path="/company/:slug" element={<ServicePage category="company" />} />
            <Route path="/page/:slug" element={<CmsPage />} />
            <Route path="/admin/cms" element={<CmsAdmin />} />
            <Route path="/admin/ai" element={<AiConsole />} />
            <Route path="/admin/crm" element={<LeadCrm />} />
            <Route path="/admin/analytics" element={<AdminAnalytics />} />
            <Route path="/admin/clients" element={<AdminClients />} />
            <Route path="/dashboard/:token" element={<ClientDashboard />} />
            <Route path="/assistant/:publicKey" element={<AssistantPage />} />
            <Route path="/foodpulse" element={<FoodPulse />} />
            <Route path="/gallery" element={<RedesignGallery />} />
            <Route path="/makeover" element={<WebsiteMakeover />} />
            <Route path="/preview/:id" element={<ConceptPreview />} />
            <Route path="/admin/gallery" element={<RedesignGallery />} />
            <Route path="/ai-chatbot" element={<AiChatbot />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            {/* WebsiteTech India instance (maps to indias.com/websitetech in production) */}
            <Route path="/in" element={<IndiaLayout />}>
              <Route index element={<IndiaHome />} />
              <Route path="services" element={<IndiaServices />} />
              <Route path="pricing" element={<IndiaPricing />} />
              <Route path="audit" element={<IndiaAudit />} />
              <Route path="contact" element={<IndiaContact />} />
              <Route path="portal" element={<IndiaPortal />} />
              <Route path=":state" element={<IndiaGeo />} />
              <Route path=":state/:city" element={<IndiaGeo />} />
            </Route>
            <Route path="/kerala" element={<KeralaLayout />}>
              <Route index element={<KeralaHome />} />
              <Route path="services" element={<KeralaServices />} />
              <Route path="pricing" element={<KeralaPricing />} />
              <Route path="audit" element={<KeralaAudit />} />
              <Route path="gallery" element={<KeralaGallery />} />
              <Route path="partners" element={<KeralaPartners />} />
              <Route path="partner-portal" element={<KeralaPartnerPortal />} />
              <Route path="contact" element={<KeralaContact />} />
            </Route>
            <Route path="/admin/country" element={<AdminCountry />} />
            <Route path="/admin/enquiries" element={<AdminEnquiries />} />
            <Route path="/admin/prospects" element={<AdminProspects />} />
            <Route path="/admin/launch-chats" element={<AdminLaunchChats />} />
            <Route path="/admin/kerala" element={<AdminKerala />} />
            <Route path="/admin/redesign" element={<AdminRedesign />} />
            <Route path="/demo/board" element={<BoardDemo />} />
            <Route path="/seo" element={<SeoIntelligence />} />
            <Route path="/seo-analyzer" element={<SeoAnalyzerPage />} />
            <Route path="/rights-queue" element={<RightsQueue />} />
            <Route path="/my-websitetech" element={<MyWebsiteTechDashboard />} />
            <Route path="/admin/seo-regression" element={<SeoRegressionDashboard />} />
            <Route path="/portal/connectors" element={<AnalyticsConnectors />} />
            {/* ─── Crescent Flexipack client site (Phase 1) ─── */}
            <Route path="/crescent" element={<CrescentI18nProvider><CrescentHome /></CrescentI18nProvider>} />
            <Route path="/crescent/request-quote" element={<CrescentI18nProvider><CrescentRequestQuote /></CrescentI18nProvider>} />
            <Route path="/crescent/products" element={<CrescentI18nProvider><CrescentProductsIndex /></CrescentI18nProvider>} />
            <Route path="/crescent/products/:slug" element={<CrescentI18nProvider><CrescentProductDetail /></CrescentI18nProvider>} />
            <Route path="/crescent/industries" element={<CrescentI18nProvider><CrescentIndustriesIndex /></CrescentI18nProvider>} />
            <Route path="/crescent/industries/:slug" element={<CrescentI18nProvider><CrescentIndustryDetail /></CrescentI18nProvider>} />
            <Route path="/crescent/capabilities" element={<CrescentI18nProvider><CrescentCapabilitiesIndex /></CrescentI18nProvider>} />
            <Route path="/crescent/capabilities/:slug" element={<CrescentI18nProvider><CrescentCapabilityDetail /></CrescentI18nProvider>} />
            <Route path="/crescent/about" element={<CrescentI18nProvider><CrescentContentPage slug="about" /></CrescentI18nProvider>} />
            <Route path="/crescent/quality" element={<CrescentI18nProvider><CrescentContentPage slug="quality" /></CrescentI18nProvider>} />
            <Route path="/crescent/sustainability" element={<CrescentI18nProvider><CrescentContentPage slug="sustainability" /></CrescentI18nProvider>} />
            <Route path="/crescent/resources" element={<CrescentI18nProvider><CrescentContentPage slug="resources" /></CrescentI18nProvider>} />
            <Route path="/crescent/contact" element={<CrescentI18nProvider><CrescentContentPage slug="contact" /></CrescentI18nProvider>} />

            {/* Growth Agent — Phase 1 vertical slice */}
            <Route path="/grow" element={<GrowIntake />} />
            <Route path="/grow/dashboard/:businessId" element={<GrowDashboard />} />
            <Route path="/grow/approvals" element={<GrowApprovals />} />
            <Route path="/grow/leads" element={<GrowLeads />} />
            <Route path="/grow/audiences" element={<GrowAudiences />} />
            <Route path="/grow/channels/:businessId" element={<GrowChannels />} />
            {/* ============ Search Intelligence™ (SEO product overhaul) ============ */}
            <Route path="/si" element={<SearchIntelligenceLanding />} />
            <Route path="/si/methodology" element={<SearchIntelligenceMethodology />} />
            <Route path="/si/sample" element={<SearchIntelligenceSample />} />
            <Route path="/si/console" element={<SearchIntelligenceConsole />} />
            <Route path="/admin/client-inventory/:client" element={<AdminClientInventory />} />
            {/* ============ Growth Operator (Work Less, Grow More) ============ */}
            <Route path="/growth-operator" element={<GrowthOperatorLanding />} />
            <Route path="/growth-operator/blueprint" element={<GrowthOperatorBlueprint />} />
            <Route path="/growth-operator/hub" element={<GrowthOperatorHub />} />
            <Route path="/growth-operator/packs/:slug" element={<GrowthOperatorPack />} />
            <Route path="/admin/growth-operator" element={<AdminGrowthOperator />} />
            <Route path="/p/:slug" element={<PublishedPage />} />
            <Route path="/audit" element={<PublicAudit />} />
            <Route path="/tools" element={<ToolsCatalog />} />
            <Route path="/growth-agent" element={<GrowthAgentPage />} />
            <Route path="/embed" element={<EmbedStudio />} />
            <Route path="/ai-visibility" element={<AiVisibility />} />
            <Route path="/ai-revenue-center" element={<RevenueCenter />} />
            <Route path="/ai-revenue-center/prospecting" element={<Prospecting />} />
            <Route path="/ai-revenue-center/receptionist" element={<Receptionist />} />
            <Route path="/ai-revenue-center/outreach" element={<Outreach />} />
            <Route path="/ai-revenue-center/timeline" element={<Timeline />} />
            <Route path="/ai-revenue-center/dashboard" element={<RevenueDashboard />} />
            <Route path="/ai-revenue-center/revival" element={<Revival />} />
            <Route path="/ai-revenue-center/trust" element={<TrustCenter />} />
            <Route path="/ai-revenue-center/packages" element={<RevenuePackages />} />
            <Route path="/whats-new" element={<WhatsNew />} />
            <Route path="/pricing" element={<PricingPage />} />
            <Route path="/platform" element={<FeaturesPage />} />
            <Route path="/features" element={<FeaturesPage />} />
            <Route path="/demos" element={<DemosIndex />} />
            <Route path="/demos/restaurant" element={<AureliaDemo />} />
            <Route path="/demos/real-estate" element={<MayaBennettDemo />} />
            <Route path="/demos/medical" element={<MedicalDemo />} />
            <Route path="/demos/law" element={<LawDemo />} />
            <Route path="/demos/spa" element={<StillwaterDemo />} />
            <Route path="/demos/elara" element={<ElaraDemo />} />
            <Route path="/demos/charity" element={<HarvestBridgeDemo />} />
            <Route path="/demos/portfolio" element={<AmaraValeDemo />} />
            <Route path="/demos/hotel" element={<SolaraCoveDemo />} />
            <Route path="/demos/salon" element={<LumeDemo />} />
            <Route path="/demos/auto" element={<PrecisionAutoDemo />} />
            <Route path="/demos/fresh" element={<FreshMarketDemo />} />
            <Route path="/demos/college" element={<CedarGroveDemo />} />
            <Route path="/demos/saas" element={<NexoraDemo />} />
            <Route path="/admin/pricing" element={<AdminPricing />} />
            <Route path="/industries" element={<IndustryPage />} />
            <Route path="/industries/:slug" element={<IndustryPage />} />
            <Route path="/admin/industry-pages" element={<AdminIndustryPages />} />
            <Route path="/admin/proposals" element={<AdminProposals />} />
            <Route path="/admin/demo-leads" element={<AdminDemoLeads />} />
            <Route path="/admin/tools" element={<AdminToolsCatalog />} />
            <Route path="/admin/whats-new" element={<AdminWhatsNew />} />
            <Route path="/admin/embed" element={<AdminEmbed />} />
            <Route path="/admin/ai-visibility" element={<AdminAiVisibility />} />
            <Route path="/admin/growth-agent" element={<AdminWorklog />} />
            <Route path="/admin/experiments" element={<AdminExperiments />} />
            <Route path="/admin/versions" element={<AdminVersions />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
          <AIAssistant />
          <TalkToAiEmployeeLauncher />
          <Toaster theme="light" position="bottom-center" />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
